import { Copy, Download } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { cardFileUrl } from "../../lib/api";
import { useLang } from "../../lib/i18n";

export const copyCardLink = async (url, t) => {
  try {
    await navigator.clipboard.writeText(url);
    toast.success(t("copied"));
  } catch {
    toast.error(url);
  }
};

export const QrDialog = ({ open, onOpenChange, card }) => {
  const { t } = useLang();
  const qrSrc = cardFileUrl(card.slug, "qr.png");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-3xl" data-testid="qr-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{card.name_en}</DialogTitle>
          <DialogDescription>{t("scan_to_open")}</DialogDescription>
        </DialogHeader>
        <div className="mx-auto rounded-2xl border border-slate-200 bg-white p-3">
          <img src={qrSrc} alt="QR code" className="h-60 w-60" data-testid="qr-image" />
        </div>
        <p dir="ltr" className="break-all text-center font-mono text-xs text-slate-500" data-testid="qr-card-url">{card.card_url}</p>
        <div className="grid grid-cols-2 gap-3">
          <button type="button" onClick={() => copyCardLink(card.card_url, t)} data-testid="qr-copy-link-button"
            className="btn-press flex min-h-[50px] items-center justify-center gap-2 rounded-2xl border border-slate-300 text-sm font-semibold hover:border-slate-900">
            <Copy className="h-4 w-4" /> {t("copy_link")}
          </button>
          <a href={qrSrc} download={`${card.slug}-qr.png`} data-testid="qr-download-button"
            className="btn-press flex min-h-[50px] items-center justify-center gap-2 rounded-2xl bg-slate-900 text-sm font-semibold text-white hover:bg-slate-800">
            <Download className="h-4 w-4" /> {t("download_qr")}
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
